import { Box } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import AddressForm from './components/AddressForm';
import AddressFormTitle from './components/AddressFormTitle';

const AddressEditPage = () => {
  return (
    <>
      <Helmet>
        <title>Edit address | Caltex StarCard</title>
      </Helmet>

      <Box sx={{ padding: '10px 16px' }}>
        <AddressFormTitle title="แก้ไขที่อยู่ใหม่" />
        <AddressForm mode="EDIT" />
      </Box>
    </>
  );
};

export default AddressEditPage;
